import { CSSProperties } from 'react';
import { minBreakpoints } from '@noths/polaris-client-ribbons-design-system';
import { mediaQuery } from '@noths/polaris-client-styles';
import { css, keyframes } from 'styled-components';

import { nothsTheme as theme } from './noths.theme';

export interface CSSVarHeight extends CSSProperties {
  '--heightMobile': string;
  '--heightDesktop': string;
}

const { color } = theme;

const placeholderAnimation = keyframes`
  0% {
    background-color: ${color.cadetBlue};
  }
  50% {
    background-color: ${color.slateGray};
  }
  100% {
    background-color: ${color.cadetBlue};
  }
`;

const animation = () => css`
  2s ${placeholderAnimation} infinite;
`;

export const Placeholder = css`
  animation: ${animation};
  position: absolute;
  top: 0;
  left: 0;
  height: var(--heightMobile, 100%);
  width: 100%;

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      height: var(--heightDesktop, 100%);
    `,
  )};
`;

export const Overlay = css`
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
`;

export const TextWrapperWithFullOverLay = css`
  position: absolute;
  width: 100%;
  top: 50%;
  left: 0;
  box-sizing: border-box;
  z-index: 3;
  transform: translateY(-50%) translate3d(0, 0, 0); /* Safari z-index fix */
`;

export const TextWrapperWithBottomOverlay = css`
  top: auto;
  bottom: 0;
  z-index: 2;
  transform: translate3d(0, 0, 0); /* Safari z-index fix */
  background-color: rgba(0, 0, 0, 0.3);
`;

export const HideElement = css`
  position: absolute;
  overflow: hidden;
  top: 0;
  left: 0;
  width: 0px;
  height: 0px;
  opacity: 0;
  white-space: nowrap;
`;
